import { type MylensesAction } from "@snapchat/blizzard-schema";

export const myLensesActionType = {
    click: "CLICK",
    submit: "SUBMIT",
} as const;

export type MyLensesActionType = (typeof myLensesActionType)[keyof typeof myLensesActionType];

export interface ActionEventData {
    event: MylensesAction["event_name"];
    actionType: MyLensesActionType;
    label: string;
    namespace: string;
}

export const createActionEvent = (
    { event, label, actionType, namespace }: ActionEventData,
    sessionId: string,
): MylensesAction => ({
    event_name: event,
    label,
    action_type: actionType,
    namespace,
    mylenses_session_id: sessionId,
});
